import { memo } from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="h-full relative flex flex-col justify-center items-center overflow-hidden">
      <div className="absolute inset-0 hero-gradient" />

      <div className="flex-grow flex justify-center items-center relative">
        <Outlet />
      </div>

      <div className="text-helper text-sm py-[36px] relative ">
        Copyright © 成都呼声科技有限责任公司 川公网安备 51019002006554号蜀ICP备2024079335号-1
      </div>
    </div>
  );
};

export default memo(AuthLayout);
